import './PlayerStats.css';

const PlayerStats = (props) => {
  const { name, average, totalWins } = props;

  return (
    <div className="PlayerStats">
      <div className="playerNameStats">{name}</div>
      <div className="playerNameAverage">{average}</div>
      <div className="playerNameTotalWins">{totalWins}</div>
    </div>
  );
};

export default PlayerStats;
